//Created by wangshuyi on 07/03/2018.

'use strict';
import dolphinCoreConfig from '../config';
let messageDialog;

const socket = function (params) {
  let param = Object.assign({}, dolphinCoreConfig.socket, params);

  return emitEvent.call(this, param).catch(e => {
      if (param.showMessage) {
          let message = e.message;
          if(this.$i18n && typeof this.$t === 'function'){
              let i18nMessage = this.$t(`systemMessage.${e.errorCode}`, e.messageInfo);
              if(i18nMessage !== `systemMessage.${e.errorCode}`){
                  message = i18nMessage;
              }
          }

          let title = '系统提示';
          if(this.$i18n && typeof this.$t === 'function'){
              let titleMessage = this.$t(`systemMessage.1`);
              if(titleMessage !== `systemMessage.1`){
                  title = titleMessage;
              }
          }

          if(window.$DolAntPage){
              if(messageDialog){
                  messageDialog.destroy();
              }
              messageDialog = window.$DolAntPage.$error({
                  title: title,
                  content: message,
              });
          }else if(window.$DolVantPage){
              window.$DolVantPage.$dialog.close();
              window.$DolVantPage.$dialog.alert({
                  title: title,
                  content: message,
              });
          }else{
              alert(message);
          }
      }
      throw e;
  })
};

function emitEvent(params, count = 1){
    return new Promise((resolve, reject) => {
        let $socket = this.$socket;
        if(!$socket.connected){
            setTimeout(() => {
                if(count < params.maxCount){
                    emitEvent.call(this, params, count+1).then(d => resolve(d)).catch(e => reject(e));
                }else{
                    reject({message: 'socket未连接'});
                }
            }, params.waitTime);
        }else{
            $socket.emit(params.event, params.data, data => {
                if(data.success){
                    resolve(data);
                }else{
                    reject(data);
                }
            });
        }
    });
}

export default socket;